<div mat-dialog-title class="dialog-info" closeOnEscape>
    <label class="dialogTitle">
       {{'PRODUCT_PROMOTION_REQUEST' | translate}}
    </label>
    <button type="button" class="btn-close btn-close-white shadow-none dialogCross" (click)="closeDialog()"></button>
</div>
<mat-dialog-content>
<div class="row mt-2" [formGroup]="productPromotionRequestForm">
    <div class="col-sm-6">
        <div class="row row-height-textarea mb-2">
            <div class="col-sm-4">
                <label> {{'PRODUCT_PROMOTION_DESCRIPTION_OF_PROJECT' | translate}}</label>
            </div>
            <div class="col-sm-8">
                <mat-form-field appearance="outline" class="col-sm-12">
                    <textarea matInput formControlName="descriptionOfProject" rows="3"></textarea>
               </mat-form-field>
            </div>
        </div>
        <div class="row row-height-textarea mb-2">
            <div class="col-sm-4">
                <label> {{'PRODUCT_PROMOTION_PREFERENCE_EXPECTED' | translate}}</label>
            </div>
            <div class="col-sm-8">
                <mat-form-field appearance="outline" class="col-sm-12">
                    <textarea matInput formControlName="preferenceExpected" rows="3"></textarea>
               </mat-form-field>
            </div>
        </div>
        <div class="row row-height contact-number-row">
            <div class="d-flex col-sm-6">
                <div class="col-sm-4"><label>{{'PRODUCT_PROMOTION_CONTACT_NUMBER' | translate}}</label></div>
                <div class="col-sm-8">
                    <mat-form-field appearance="outline" class="col-sm-12">
                        <input matInput formControlName="contactNumber" type="tel" mask="(000) 000-0000">
                   </mat-form-field>
                </div>
            </div>
            <div class="d-flex col-sm-6">
                <div class="col-sm-6"><label>{{'PRODUCT_PROMOTION_REQUIRED_GM' | translate}}</label></div>
                <div class="col-sm-6">
                    <mat-form-field appearance="outline" class="col-sm-12">
                        <input matInput [appNumericMask]="requiredGMConfig" [showStepper]="true" class="text-right" formControlName="requiredGM">
                   </mat-form-field>
                </div>
            </div>
        </div>
        <div class="row row-height">
            <div class="d-flex col-sm-6">
                <div class="col-sm-4"><label>{{'PRODUCT_PROMOTION_PROPOSAL_DATE' | translate}}</label></div>
                <div class="col-sm-8">
                    <mat-form-field appearance="outline" class="col-sm-12">
                        <input matInput [matDatepicker]="proposalDatePicker" formControlName="proposalDate">
                        <mat-datepicker-toggle matSuffix [for]="proposalDatePicker"></mat-datepicker-toggle>
                        <mat-datepicker #proposalDatePicker></mat-datepicker>
                    </mat-form-field>
                </div>
            </div>
            <div class="d-flex col-sm-6">
                <div class="col-sm-6"><label>{{'PRODUCT_PROMOTION_REQUIRED_DISCOUNT' | translate}}</label></div>
                <div class="col-sm-6">
                    <mat-form-field appearance="outline" class="col-sm-12">
                        <input matInput [appNumericMask]="requiredDiscountConfig" [showStepper]="true" class="text-right" formControlName="requiredDiscount">
                   </mat-form-field>
                </div>
            </div>
        </div>
        <div class="row row-height pt-2">
            <div class="col-sm-4"><label>{{'PRODUCT_PROMOTION_JOB_START_DATE' | translate}}</label></div>
            <div class="col-sm-8">{{getFormStringValue('jobStartDate') | date:'MM/dd/yyyy'}}</div>
        </div>
        <div class="row row-height">
            <div class="col-sm-4"><label>{{'PRODUCT_PROMOTION_AFFECTED_MATERIAL' | translate}}</label></div>
            <div class="col-sm-8">{{getFormStringValue('affectedMaterials')}}</div>
        </div>
    </div>
    <div class="col-sm-6">
        <div class="row row-height">
            <div class="col-sm-4">
                <label>{{'PRODUCT_PROMOTION_AUTHORIZATION_NUMBER' | translate}}</label>
            </div>
            <div class="col-sm-8">{{getFormStringValue('authorization')}}</div>
        </div>
        <div class="row row-height">
            <div class="col-sm-4">
                <label>{{'PRODUCT_PROMOTION_BUSINESS' | translate}}</label>
            </div>
            <div class="col-sm-8">{{getFormStringValue('business')}}</div>
        </div>
        <div class="row row-height">
            <div class="col-sm-4">
                <label>{{'PRODUCT_PROMOTION_REQUESTOR' | translate}}</label>
            </div>
            <div class="col-sm-8">{{getFormStringValue('requestor')}}</div>
        </div>
        <div class="row row-height">
            <div class="col-sm-4">
                <label>{{'PRODUCT_PROMOTION_SALES_OFFICE' | translate}}</label>
            </div>
            <div class="col-sm-8">{{getFormStringValue('salesOffice')}}</div>
        </div>
        <div class="row row-height">
            <div class="col-sm-4">
                <label>{{'PRODUCT_PROMOTION_CUSTOMER' | translate}}</label>
            </div>
            <div class="col-sm-6">
                <mat-form-field appearance="outline" class="col-sm-12">
                    <input matInput formControlName="customerName">
                </mat-form-field>
            </div>
            <div class="col-sm-2">
                <button mat-button color="primary" [disabled]="disableSearchBtn" (click)="openCustomerDialog()">...</button>
            </div>
        </div>
        <div class="row row-height">
            <div class="col-sm-4">{{'PRODUCT_PROMOTION_END_USER' | translate}}</div>
            <div class="col-sm-6">
                <mat-form-field appearance="outline" class="col-sm-12">
                    <input matInput formControlName="endUser">
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <fieldset class="estimate-details">
                <legend class="mb-1">{{'PRODUCT_PROMOTION_ESTIMATE_DETAILS' | translate}}</legend>
                <div class="row">
                    <div class="col-sm-6">
                        <label  class="mt-2">{{'PRODUCT_PROMOTION_CPS_MATERIAL_ESTIMATED_VALUE' | translate}}</label>
                    </div>
                    <div class="col-sm-6 mt-2 text-align-end">{{getFormNumberValue('cpsMaterialEstimatedValue') | multilingualCurrency}}</div>
                </div>
                <div class="row">
                    <div class="col-sm-6">
                        <label  class="mt-2">{{'PRODUCT_PROMOTION_ESTIMATED_SELL_PRICE' | translate}}</label>
                    </div>
                    <div class="col-sm-6 mt-2 text-align-end">{{getFormNumberValue('estimatedSellPrice') | multilingualCurrency}}</div>
                </div>
                <div class="row">
                    <div class="col-sm-6">
                        <label  class="mt-2">{{'PRODUCT_PROMOTION_GM_PERCENT' | translate}}</label>
                    </div>
                    <div class="col-sm-6 mt-2 text-align-end">{{getFormNumberValue('gm_percent')  | number:'1.2-2'}}%</div>
                </div>
            </fieldset>
        </div>
        <div class="row row-height">
            <div class="col-sm-6">
                <mat-checkbox color="primary" formControlName="overrideRequirements"></mat-checkbox><label>{{'PRODUCT_PROMOTION_OVERRIDE_REQUIREMENTS' | translate}}</label>
            </div>
        </div>
    </div>
</div>
</mat-dialog-content>
 <mat-dialog-actions align="end">
      <button mat-button color="primary" mat-dialog-close>{{'PRODUCT_PROMOTION_HELP' | translate}}</button>
      <button mat-button color="primary" [disabled]="disableSubmitBtn()" (click)="onRequestBtnClick()">{{'PRODUCT_PROMOTION_SUBMIT' | translate}}</button>
      <button mat-button color="warn" (click)="closeDialog()">{{'CANCEL_BTN_LABEL' | translate}}</button>
</mat-dialog-actions>